import { defineStore } from 'pinia'
import { v4 as uuidv4 } from 'uuid'

interface ErrorItem {
  id: string
  message: string
}

interface ErrorState {
  errors: ErrorItem[]
}

export const DEFAULT_ERROR_MESSAGE = 'Oops! Something has gone wrong'

export const useErrorStore = defineStore('error', {
  state: (): ErrorState => ({
    errors: [],
  }),
  actions: {
    addError(message: string) {
      const error = { id: uuidv4(), message }
      this.errors.push(error)
    },
    clearErrors() {
      this.errors = []
    },
    removeError(id: string) {
      this.errors = this.errors.filter((error) => error.id !== id)
    },
  },
})
